import React from 'react';

const SvgCheckInOutActive = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.454 20.447C16.999 19.171 15.994 18.044 14.597 17.24C13.2 16.436 11.488 16 9.727 16C7.966 16 6.254 16.436 4.857 17.24C3.46 18.044 2.455 19.171 2 20.447"
        stroke="#0081FF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.72701 12C11.9361 12 13.727 10.2091 13.727 8C13.727 5.79086 11.9361 4 9.72701 4C7.51787 4 5.72701 5.79086 5.72701 8C5.72701 10.2091 7.51787 12 9.72701 12Z"
        stroke="#0081FF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M15 11.5L17.5 14L21.5 10" stroke="#0081FF" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export default SvgCheckInOutActive;
